// en
import enCalendar from '@/assets/locales/en/calendar.json';
import enCapabilities from '@/assets/locales/en/capabilities.json';
import enCommons from '@/assets/locales/en/commons.json';
import enComponents from '@/assets/locales/en/components.json';
import enDiscounts from '@/assets/locales/en/discounts.json';
import enErrors from '@/assets/locales/en/errors.json';
import enEvents from '@/assets/locales/en/events.json';
import enExports from '@/assets/locales/en/exports.json';
import enLocales from '@/assets/locales/en/locales.json';
import enMercure from '@/assets/locales/en/mercure.json';
import enOperations from '@/assets/locales/en/operations.json';
import enReports from '@/assets/locales/en/reports.json';
import enSubscribers from '@/assets/locales/en/subscribers.json';
import enSubscriptions from '@/assets/locales/en/subscriptions.json';
import enWebpages from '@/assets/locales/en/webpages.json';
// es
import esCalendar from '@/assets/locales/es/calendar.json';
import esCapabilities from '@/assets/locales/es/capabilities.json';
import esCommons from '@/assets/locales/es/commons.json';
import esComponents from '@/assets/locales/es/components.json';
import esDiscounts from '@/assets/locales/es/discounts.json';
import esErrors from '@/assets/locales/es/errors.json';
import esEvents from '@/assets/locales/es/events.json';
import esExports from '@/assets/locales/es/exports.json';
import esLocales from '@/assets/locales/es/locales.json';
import esMercure from '@/assets/locales/es/mercure.json';
import esOperations from '@/assets/locales/es/operations.json';
import esReports from '@/assets/locales/es/reports.json';
import esSubscribers from '@/assets/locales/es/subscribers.json';
import esSubscriptions from '@/assets/locales/es/subscriptions.json';
import esWebpages from '@/assets/locales/es/webpages.json';

//

const es = {
    calendar: esCalendar,
    capabilities: esCapabilities,
    commons: esCommons,
    components: esComponents,
    discounts: esDiscounts,
    errors: esErrors,
    events: esEvents,
    exports: esExports,
    locales: esLocales,
    mercure: esMercure,
    operations: esOperations,
    reports: esReports,
    subscribers: esSubscribers,
    subscriptions: esSubscriptions,
    webpages: esWebpages,
} as const;

//

const en = {
    calendar: enCalendar,
    capabilities: enCapabilities,
    commons: enCommons,
    components: enComponents,
    discounts: enDiscounts,
    errors: enErrors,
    events: enEvents,
    exports: enExports,
    locales: enLocales,
    mercure: enMercure,
    operations: enOperations,
    reports: enReports,
    subscribers: enSubscribers,
    subscriptions: enSubscriptions,
    webpages: enWebpages,
} as const;

//

export const RESOURCES = { es, en } as const;

export const DEFAULT_NS = 'commons' as const;

export const NAMESPACES = Object.keys(es);

export type Resources = typeof es;

// NOTE: check both satisfies to ensure both files have the exact json keys

enCalendar satisfies typeof esCalendar;
enCapabilities satisfies typeof esCapabilities;
enCommons satisfies typeof esCommons;
enComponents satisfies typeof esComponents;
enDiscounts satisfies typeof esDiscounts;
enErrors satisfies typeof esErrors;
enEvents satisfies typeof esEvents;
enExports satisfies typeof esExports;
enLocales satisfies typeof esLocales;
enMercure satisfies typeof esMercure;
enOperations satisfies typeof esOperations;
enReports satisfies typeof esReports;
enSubscribers satisfies typeof esSubscribers;
enSubscriptions satisfies typeof esSubscriptions;
enWebpages satisfies typeof esWebpages;

esCalendar satisfies typeof enCalendar;
esCapabilities satisfies typeof enCapabilities;
esCommons satisfies typeof enCommons;
esComponents satisfies typeof enComponents;
esDiscounts satisfies typeof enDiscounts;
esErrors satisfies typeof enErrors;
esEvents satisfies typeof enEvents;
esExports satisfies typeof enExports;
esLocales satisfies typeof enLocales;
esMercure satisfies typeof enMercure;
esOperations satisfies typeof enOperations;
esReports satisfies typeof enReports;
esSubscribers satisfies typeof enSubscribers;
esSubscriptions satisfies typeof enSubscriptions;
esWebpages satisfies typeof enWebpages;
